<template>
<div>
    <div class="w-full md:w-1/2 mx-auto my-12 text-center">
        <p class="text-2xl main-text md:text-3xl xl:text-4xl font-semibold text-center md:font-bold  m-4">
            <span>What Students Say</span><br />
        </p>
        <span class="text-xs negative-top text-grey
      ">{{testimonialText}}</span>
    </div>
    <div class="mx-4 no-shadow">

        <carousel-3d :controls-visible="true" :height="280" :perspective="0" :space="400" :display="3">
            <slide v-for="(testimonial , index) in getTestimonials" :index="index" :key="index">
                <template>
                    <div class=" w-full " style="width:100%; height:100%">
                        <div class="shadow-lg bg-white rounded-b  p-4 flex flex-col justify-between leading-normal">
                            <div class="text-center mb-3">
                                <p class="text-6xl main-text">
                                    ''
                                </p>
                                <p class="text-gray-700 text-base mb-4">
                                    {{testimonial.testimonial}}
                                </p>
                                <p class="text-gray-700 text-base mb-4">
                                    Course: {{testimonial.course.title}}
                                </p>
                            </div>
                            <div class="flex items-center">
                                <img class="w-10 h-10 rounded-full mr-4" v-if="testimonial.user.image" :src="testimonial.user.image" />
                                <img v-else class="w-10 h-10 rounded-full mr-4" src="../../../assets/avatar.svg" />

                            </div>
                            <div class="text-sm">
                                <p class="main-text leading-none">{{testimonial.user.first_name + ' ' + testimonial.user.last_name}}</p>
                                <p class="text-gray-600">{{testimonial.created_at | fromNow}}</p>
                            </div>
                        </div>
                    </div>
                </template>
            </slide>
        </carousel-3d>
    </div>
</div>
</template>

<script>
import {
    VueperSlides,
    VueperSlide
} from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import SettingsMixin from "@/mixins/SettingsMixin"
import {
    Carousel3d,
    Slide
} from 'vue-carousel-3d';
export default {
    mixins: [SettingsMixin],
    components: {
        lcourses: () => import("@/components/shared/home/course-card"),
        linput: () => import("@/components/general/input"),
        VueperSlides,
        VueperSlide,
        Carousel3d,
        Slide
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.my-body {
    background: #fff;
}

.text-grey {
    color: #5c5c5c;
}

.main-text {
    color: color(lms-tenant);
}

.negative-top {
    margin-top: -0.5em;
}

.vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper:after {
    box-shadow: none !important;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
}
</style>
